import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const useWeekDays = (withSessions = false) => {
  const { t } = useTranslation();
  const [weekDays, setWeekDays] = useState(null);

  const days = [
    {
      name: t('GENERAL.days_1'),
      value: '1',
    },
    {
      name: t('GENERAL.days_2'),
      value: '2',
    },
    {
      name: t('GENERAL.days_3'),
      value: '3',
    },
    {
      name: t('GENERAL.days_4'),
      value: '4',
    },
    {
      name: t('GENERAL.days_5'),
      value: '5',
    },
    {
      name: t('GENERAL.days_6'),
      value: '6',
    },
    {
      name: t('GENERAL.days_7'),
      value: '7',
    },
  ];

  if (!weekDays && !withSessions) {
    setWeekDays(days);
  }

  if (!weekDays && withSessions) {
    setWeekDays(
      days.map(day => {
        day.sessions = [];
        return day;
      })
    );
  }

  return weekDays;
};

export { useWeekDays };
